import { patchState, signalStoreFeature, type, withMethods } from "@ngrx/signals";
import { IAuthenticationState, initialAuthenticationState } from "./auth.state";
import { AuthToken } from "../../models/auth/auth-token.model";

export const withAuthenticationStateMethods = signalStoreFeature(
    { state: type<IAuthenticationState>() },
    withMethods((store) => ({
        storeAuthToken: (authToken: AuthToken) => {
            patchState(store, { authToken, isAuthenticated: true, loading: false, error: null });
        },
        clearAuth: () => {
            patchState(store, initialAuthenticationState);
        }
    }))
);